export default "__VITE_ASSET__FQcjFIYN__"